/* eslint-disable react/jsx-no-useless-fragment */
import { ReactElement } from 'react';
import { useCAWContext } from '../CAW';
import classnames from 'classnames';
import { translate } from '@micro-apps/env';
import { PlanStore } from '@micro-apps/stores';
const renderButton = (item, index, planStore: PlanStore) => {
	if (!item) {
		return null;
	}

	const buttonClass = classnames(
		'Button--secondary--dark flexdates-button min-w-[60px] px-[8px] py-[10px]',
		{
			selected: item === planStore?.search.flexDatesSelected,
		}
	);

	const buttonText = ` ${item} ${translate('days')}`;
	return (
		<button
			key={index.toString()}
			className={buttonClass}
			onClick={() => {
				planStore?.updateSearch({
					flexDatesSelected: planStore?.search.flexDatesSelected === item ? 0 : item,
				});
			}}
		>
			&plusmn;{buttonText}
		</button>
	);
};
export default function FlexDates(): ReactElement<any> {
	const { planStore } = useCAWContext();
	const flexDates = planStore?.destination?.bookingConfig?.flexDates?.daysRange;

	const buttons = flexDates?.map((item, index) => {
		return renderButton(item, index, planStore!);
	});

	if (!flexDates || !flexDates.length) {
		return <></>;
	}

	return (
		<div className="Flex-Dates-inner text-center">
			<p className="Flex-Dates-label ty-c2 mb-[10px]">{translate('Are your dates flexible?')}</p>
			{buttons}
		</div>
	);
}
